<template>
  <div>
      <div v-if="showImport">
        <v-alert
          dense
          text
          type="info"
          v-if="rawFile === undefined || rawFile === null"
          transition="fade-transition"
        >
        Por favor subir el <strong>excel</strong> con los pedidos que deseas importar
      </v-alert>
      <v-alert
          dense
          text
          type="info"
          v-else
        >
        Por favor hacer click en el <strong>botón</strong> importar
      </v-alert>
        <h4 class="mb-1"><v-icon right>mdi-file-document-edit-outline</v-icon> Importar Pedido</h4>
        <v-file-input
          show-size
          counter
          truncate-length="20"
          label="Archivo Excel"
          v-model="rawFile"
          :disabled="loadingBrowse === true || rawFile !== undefined"
        ></v-file-input>
      </div>
      <div class="text-center" v-if="showImportPedido">
        <v-btn
          color="primary"
          class="mt-4"
          @click="handleUpload"
          :loading="loadingBrowse"
          :disabled="loadingBrowse || rawFile === undefined"
        >
          Importar
        </v-btn>
      </div>

      <div v-if="showDetail" class="mt-4 red lighten-5 py-4 px-2">
      <v-card :elevation="2" class="rounded-lg py-4 px-2">
        
        <h2 class="mb-1" v-if="loadingBrowse"><v-progress-circular
          color="info"
          indeterminate
          :size="32"
          :width="4"
        ></v-progress-circular> {{ title }} {{  subtitle }}</h2>
        <h2 class="mb-1" v-else> Detalles del Pedido Importado - Codigo: <strong style="color: orange">{{ codigo_pedido }}</strong></h2>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>
              <v-layout wrap class="py-2">
                <span style="color: blue" class="mt-2"
                  >Total de pedidos a importar:
                  <b>{{ totalImportar }}</b></span
                >
                <v-spacer></v-spacer>
                <span style="color: green" class="mt-2"
                  >Importados Correctamente:
                  <b>{{ this.importarCorrecto }}</b></span
                >
                <v-spacer></v-spacer>
                <span style="color: red" class="mt-2"
                  >No se pudieron importar:
                  <b>{{ this.importarIncorrecto }}</b></span
                >
                <v-spacer></v-spacer>
                <v-btn
                  color="error"
                  outlined
                  @click="dialogVisible = !dialogVisible"
                  v-if="incorrectos && !loadingBrowse"
                  >Ver incorrectos</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  color="error"
                  :to="'/pedidos/entry'"
                  v-if="!loadingBrowse && importTextBool"
                >Cerrar
                </v-btn>
              </v-layout>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-simple-table dense v-if="dialogVisible">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Filas</th>
                <th class="text-left">Errores</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in importErrors" :key="item.error">
                <td>{{ item.fila }}</td>
                <td v-html="item.error"></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </div>
    </div>
</template>
<script>
  import XLSX from "xlsx"
  import HTTP from "@/http"
  import { mapState, mapMutations, mapActions, mapGetters } from "vuex"
  import messageMixin from "@/mixins/common"

  export default {
    mixins: [messageMixin],
    components: {},

    data() {
      return {
        dialogVisible: false,
        importarStatus: 0,
        loadingBrowse: false,
        importTextBool: false,
        showImportPedido: true,
        importarCorrecto: 0,
        importarIncorrecto: 0,
        totalImportar: 0,
        montoPagado: 0,
        errores: [],
        importadosID: [],
        showImport: true,
        showDetailsImport: false,
        rawFile: undefined,
        title: 'Importando Pedido ',
        subtitle: '...',
        pedido_id: undefined,
        codigo_pedido: undefined,
        persona_id: undefined,
        montoCilindros: [
          {
            id: 1,
            precio: 28,
            frecuencia: 16,
            kg: '10 KG'
          },
          {
            id: 2,
            precio: 56,
            frecuencia: 30,
            kg: '18 KG'
          },
          {
            id: 3,
            precio: 84,
            frecuencia: 50,
            kg: '27 KG'
          },
          {
            id: 11,
            precio: 140,
            frecuencia: 80,
            kg: '43 KG'
          },
        ],
        excelData: {
          header: null,
          results: null,
        },
      }
    },

    computed: {
    ...mapState("Comunidades", ["selected_comunidad"]),
      incorrectos() {
        return this.importarIncorrecto > 0
      },
      importErrors() {
        return this.errores
      },
      showDetail() {
        return this.showDetailsImport
      },
    },

    methods: {
      handleCloseImportarBox() {
        this.showDetailsImport = false;
      },

      async handleUpload() {
        if (this.selected_comunidad === null || this.selected_comunidad === 0) {
          this.$swal.fire({
            title: "Comunidad es Requeridad",
            text: "Debes seleccionar la comunidad",
            icon: "error",
          })
          return false
        }
        let comunidadId = this.selected_comunidad
        let rawFile = this.rawFile
        this.showDetailsImport = true
        this.importarCorrecto = 0
        this.importarIncorrecto = 0
        this.montoTotal = 0
        this.importTextBool = false
        this.errores = []
        this.importadosID = []
        this.showImportPedido = false
        this.$emit('hiddenImportFalse')
        this.showDetailsImport = true;
        this.readerData(rawFile, comunidadId)
      },

      readerData(rawFile, comunidadId) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: "array" })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const header = this.getHeaderRow(worksheet)
          const results = this.getResutlsRow(worksheet, header)
          this.generateData({ header, results }, comunidadId)
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },

    getHeaderRow(sheet) {
      const headers = ['cedula', 'cilindroDiez', 'cilindroDieciOcho', 'cilindroVeintiSiete', 'cilindroCuarentaYTres', 'metodoPago', 'tipoPago', 'fechaPago', 'codigoPago', 'MontoPago'];
      return headers
    },
    getResutlsRow(sheet, header) {
      const results = []
      const range = XLSX.utils.decode_range(sheet["!ref"])
      range.s.r = 2 // Start Row
      range.e.c = header.length
      let C
      let R
      for (R = range.s.r; R <= range.e.r; ++R) {
        const object = {}
        for (C = range.s.c; C <= range.e.c; ++C) {
          /* walk every column in the range */
          const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
          /* find the cell in the first row */
          if (cell && cell.t) {
            const key = header[C]
            object[key] = cell.v
            /*if (key === 'fechadeemision') {
              object[key] = cell.w;
            }*/
          }
        }
        if (Object.keys(object).length === 0) {
          continue
        }
        results.push(object)
      }
      return results
    },

    generateData({ header, results }, comunidadId) {

      function validarCampos(row, fila) {
        let bool = false
        if (row.cedula === undefined || row.cedula === '' || row.cedula === null) {
          const rowError = {
            fila: fila,
            error: "Número de cedula es un campo requerido",
          }
          bool = true
        }
        if (row.cedula !== undefined && row.cedula.length <= 6) {
          const rowError = {
            fila: fila,
            error: "Número de cedula no es valido",
          }
          bool = true
        }

        let cilindroDiez = row.cilindroDiez ?? 0
        let cilindroDieciOcho = row.cilindroDieciOcho ?? 0
        let cilindroVeintiSiete = row.cilindroVeintiSiete ?? 0
        let cilindroCuarentaYTres = row.cilindroCuarentaYTres ?? 0

        if (
          cilindroDiez === 0 &&
          cilindroDieciOcho === 0 &&
          cilindroVeintiSiete === 0 &&
          cilindroCuarentaYTres === 0
        ) {
          const rowError = {
            fila: fila,
            error: "No se indico la cantidad de cilindro a comprar",
          }
          bool = true
        }

        return bool
      }

      let fila = 3
      const $this = this

      function resetImport() {
        $this.importarCorrecto = 0
        $this.importarIncorrecto = 0
        $this.montoTotal = 0
        $this.importTextBool = false
        $this.errores = []
        $this.importadosID = []
      }

      async function guardar(pedido) {
        if (pedido.fila === 3 && $this.pedido_id === undefined || $this.pedido_id === undefined) {
          let info = {
            comunidad: pedido.comunidad.toString()
          };
          await HTTP()
            .post("/pedidos/create", info)
            .then((response) => {
              $this.pedido_id = response.data.data.id;
              $this.codigo_pedido = response.data.data.codigo;
            })
            .catch((error) => {
              const errors = 'No se pudo concectar con el servidor. Pedido no creado';
              const rowError = { fila: pedido.fila, error: errors }
              $this.errores.push(rowError)
              $this.loadingBrowse = false
            })
        }
        if (pedido.cedula && $this.pedido_id !== undefined) {
          $this.loadingBrowse = true

          let verificar = {
            search: pedido.cedula.toString(),
            comunidad:  pedido.comunidad.toString()
          };

          // Verificar si la persona existe y pertenece a la comununidad
          let validar = 0;
          await HTTP()
          .post("/personas/search", verificar)
          .then((response) => {
            // persona existe y pertenece a la comununidad
              validar = 1;
              $this.persona_id = response.data.data.id
            
          })
          .catch((error) => {
            $this.importarIncorrecto++
            let errors = error.response.data.messages
            if ( errors === 'common.NO_RECORDS') {
              errors = '<strong>Cédula: </strong> <span style="color: red">'+ pedido.cedula +'</span> no se encuentra registrada.'
            }
            const rowError = { fila: pedido.fila, error: errors }
              $this.errores.push(rowError)
          })

          // Importar pagos
          if (pedido.MontoPago !== undefined && pedido.fechaPago !== undefined && $this.pedido_id !== undefined) {
            let pagos = {
              metodoPago: pedido.metodoPago?.toString(),
              tipoPago: pedido.tipoPago?.toString(),
              fechaPago: pedido.fechaPago?.toString(),
              codigoPago: pedido.codigoPago?.toString(),
              MontoPago: pedido.MontoPago?.toString(),
              pedido_id:  $this.pedido_id?.toString()
            };

            await HTTP()
              .post("/pedidos/pagar", pagos)
              .then((response) => {
                $this.montoPagado =  $this.montoPagado + pagos.MontoPago;
              }).catch((errorPago) => {
                  const errors = 'No se pudo registrar el pago';
                  const rowError = { fila: pedido.fila, error: errors }
                  $this.errores.push(rowError)
                
              });

          }

          if (validar === 1 && $this.persona_id > 0) {
            let cilindros = [];
            if ( pedido.cilindroDiez > 0) {
              let bombonas = {
                cantidad: pedido.cilindroDiez?.toString(),
                monto: $this.montoCilindros[0].precio?.toString(),
                tps_bombonas: $this.montoCilindros[0].id?.toString(),
                frecuencia: $this.montoCilindros[0].frecuencia?.toString(),
                kg: $this.montoCilindros[0].kg?.toString(),
              }

              cilindros.push(bombonas)
            }

            if ( pedido.cilindroDieciOcho > 0) {
              let bombonas = {
                cantidad: pedido.cilindroDieciOcho?.toString(),
                monto: $this.montoCilindros[1].precio?.toString(),
                tps_bombonas: $this.montoCilindros[1].id?.toString(),
                frecuencia: $this.montoCilindros[1].frecuencia?.toString(),
                kg: $this.montoCilindros[1].kg?.toString(),
              }

              cilindros.push(bombonas)
            }

            if ( pedido.cilindroVeintiSiete > 0) {
              let bombonas = {
                cantidad: pedido.cilindroVeintiSiete?.toString(),
                monto: $this.montoCilindros[2].precio?.toString(),
                tps_bombonas: $this.montoCilindros[2].id?.toString(),
                frecuencia: $this.montoCilindros[2].frecuencia?.toString(),
                kg: $this.montoCilindros[2].kg?.toString(),
              }

              cilindros.push(bombonas)
            }

            if ( pedido.cilindroCuarentaYTres > 0) {
              let bombonas = {
                cantidad: pedido.cilindroCuarentaYTres?.toString(),
                monto: $this.montoCilindros[3].precio?.toString(),
                tps_bombonas: $this.montoCilindros[3].id?.toString(),
                frecuencia: $this.montoCilindros[3].frecuencia?.toString(),
                kg: $this.montoCilindros[3].kg?.toString(),
              }

              cilindros.push(bombonas)
            }

            let data = {
            cedula: pedido.cedula.toString(),
            persona_id: $this.persona_id,
            pedido_id: $this.pedido_id,
            cilindros: cilindros,
          }
            return await HTTP()
              .post("/pedidos/import", data)
              .then((response) => {
                $this.importarCorrecto++
                $this.loadingBrowse = false
                if (response.data.data) {
                  const message =  '<strong>Cédula: </strong> <span style="color: orange">'+ pedido.cedula +'</span> ' + response.data.data[0]
                  const rowError = { fila: pedido.fila, error: message }
                  $this.errores.push(rowError)
                }
              })
              .catch((error) => {
                $this.importarIncorrecto++
                const errors = error.response.data.messages
                const rowError = { fila: pedido.fila, error: errors }
                $this.errores.push(rowError)
                $this.loadingBrowse = false
              })
          }
          return;
        }
      }

      this.excelData.header = header
      this.excelData.results = results

      $this.importTextBool = true
      $this.importarCorrecto = 0
      $this.importarIncorrecto = 0
      $this.totalImportar = results.length ?? 0
      $this.showImport = false
      let promise = Promise.resolve()

      this.excelData.results.forEach(async function (item, index) {
        promise = promise.then(async function () {

          if (validarCampos(item, fila)) {
            fila++
            $this.importarIncorrecto++
            return
          }

          const pedido = {
            cedula: item.cedula,
            cilindroDiez: item.cilindroDiez,
            cilindroDieciOcho: item.cilindroDieciOcho,
            cilindroVeintiSiete: item.cilindroVeintiSiete,
            cilindroCuarentaYTres: item.cilindroCuarentaYTres,
            metodoPago: item.metodoPago,
            tipoPago: item.tipoPago,
            fechaPago: item.fechaPago,
            codigoPago: item.codigoPago,
            MontoPago: item.MontoPago,
            comunidad: comunidadId,
            fila: fila
          }

          await guardar(pedido)
            fila++

        })
      })   
      
      promise.then(function () {
        setTimeout(function () {
          $this.loadingBrowse = false
          $this.importarStatus = 0
          let mensaje =
            "Se importaron " +
            $this.importarCorrecto +
            " registros de Pedidos de " +
            $this.totalImportar +
            " a importar"

          if ($this.importarIncorrecto > 0) {
            mensaje +=
              '<br><span style="color: red">Registros de Pedidos con error: ' +
              $this.importarIncorrecto +
              "</span>"
          }
          $this.$swal.fire({
            title: "Importar Pedidos ha Finalizado",
            html: mensaje,
            icon: "success",
          })

          //$this.$emit('getList')
        }, 1 * 1000)
      })

    }

    } // Methods
  }
</script>